import React, { useEffect } from "react";
import {
  clearLocalStorage,
  getLocalStorage,
  handleDeleteCookie,
  handleGetCookie,
} from "../../utils/commonUtil";
import { postRequest } from "../../api/apiHelpers";

const Logout = () => {
  useEffect(() => {
    const logout = async () => {
      const auth = getLocalStorage("auth") || handleGetCookie("auth") || null;

      try {
        // Log the explicit logout before local authentication data is cleared.
        // accessToken is redacted by the server-side action logger.
        if (auth?.accessToken) {
          await postRequest({
            url: "/token/logout",
            data: { accessToken: auth.accessToken },
            showLoading: false,
            showAlert: false,
          });
        }
      } catch (_) {
        // Logout must still finish even if the audit request cannot be sent.
      } finally {
        clearLocalStorage("auth");
        handleDeleteCookie("auth");
        window.location.replace("/");
      }
    };

    logout();
  }, []);

  return (
    <div>
      <p>Logging out...</p>
    </div>
  );
};

export default Logout;
